import { getTodayMatches } from "../../js/api/featuredPreMatch.js";
import { getPrematchGamesMainLeague } from "../../js/api/mainLeagueMatch.js";
import { _t } from "../../services/TranslationService.js";
import { LOGIN_PROTECTED } from "../../js/constants/global-variables.js";

let timers = [];

const matchFilterModes = {
  "1": {
    hours: 24,
    label: "Ndeshjet Sot",
  },
  "2": {
    hours: 2,
    label: "Ndeshjet 2 orët e ardhshme",
  },
  "3": {
    hours: 4,
    label: "Ndeshjet 4 orët e ardhshme",
  },
};

const getMatchFilterMode = () => {
  const path = (window.location.hash || window.location.pathname).split("?")[0];
  const requestedMode = path.split("/").filter(Boolean).pop();

  return matchFilterModes[requestedMode] ? requestedMode : "1";
};

const parseMatchTimestamp = (match) => {
  const dateParts = String(match.game_date || "").match(
    /^(\d{4})-(\d{1,2})-(\d{1,2})/,
  );
  const timeParts = String(match.game_time || "").match(
    /^(\d{1,2}):(\d{2})(?::(\d{2}))?/,
  );

  // Use the same local date and time that are displayed beside the match.
  if (dateParts && timeParts) {
    return new Date(
      Number(dateParts[1]),
      Number(dateParts[2]) - 1,
      Number(dateParts[3]),
      Number(timeParts[1]),
      Number(timeParts[2]),
      Number(timeParts[3] || 0),
    ).getTime();
  }

  const dateValues = [match.whole_date];

  for (const dateValue of dateValues) {
    if (!dateValue) continue;

    const normalizedDateValue =
      typeof dateValue === "string"
        ? dateValue.replace(
            /^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}(?::\d{2})?)/,
            "$1T$2",
          )
        : dateValue;
    const timestamp = new Date(normalizedDateValue).getTime();

    if (Number.isFinite(timestamp)) return timestamp;
  }

  return Number.NaN;
};

let Landing = {
  render: async () => {
    // if (LOGIN_PROTECTED === true && !localStorage.getItem("access_token")) {
    //   return "";
    // }

    const mode = getMatchFilterMode();
    const { hours: hoursWindow, label: selectedLabelKey } =
      matchFilterModes[mode];
    const now = Date.now();
    const filterEnd = now + hoursWindow * 60 * 60 * 1000;
    const matches = await getTodayMatches();

    const todayMatches = (Array.isArray(matches) ? matches : [])
      .map((match) => ({
        ...match,
        whole_date_timestamp: parseMatchTimestamp(match),
      }))
      .filter(
        (match) =>
          Number.isFinite(match.whole_date_timestamp) &&
          match.whole_date_timestamp >= now &&
          match.whole_date_timestamp <= filterEnd,
      )
      .sort((a, b) => a.whole_date_timestamp - b.whole_date_timestamp);

    const generateMatchesView = (matches) => {
      let matchesView = "";

      if (!matches || (matches && matches.length === 0))
        return `<p style="color: white; font-size: 12px; padding: 15px;">${_t("Nuk ka ndeshje për momentin")}</p>`;

      const uniqueLeaguesTodayMatches = [
        ...new Set(matches.map((item) => item.league_id)),
      ];

      const months = {
        "01": "month.january",
        "02": "month.february",
        "03": "month.march",
        "04": "month.april",
        "05": "month.may",
        "06": "month.june",
        "07": "month.july",
        "08": "month.august",
        "09": "month.september",
        10: "month.october",
        11: "month.november",
        12: "month.december",
      };

      const days = [
        "day.sunday",
        "day.monday",
        "day.tuesday",
        "day.wednesday",
        "day.thursday",
        "day.friday",
        "day.saturday",
      ];

      uniqueLeaguesTodayMatches.forEach((leagueId) => {
        let leagueView = "";
        let leagueName = "";

        const leagueMatches = matches.filter((a) => a.league_id === leagueId);
        leagueName = leagueMatches[0]?.league || "";

        const groupedByDate = {};

        leagueMatches.forEach((match) => {
          if (!groupedByDate[match.game_date]) {
            groupedByDate[match.game_date] = [];
          }
          groupedByDate[match.game_date].push(match);
        });

        Object.keys(groupedByDate).forEach((dateKey) => {
          const date = new Date(dateKey);
          let dd = String(date.getDate()).padStart(2, "0");
          let mm = String(date.getMonth() + 1).padStart(2, "0");
          const dayName = _t(days[date.getDay()]);
          const monthName = _t(months[mm]);

          let singleDateMatchesView = "";

          groupedByDate[dateKey].forEach((todayMatch) => {
            if (todayMatch.odd) {
              const time = `${todayMatch.game_time.split(":")[0]}:${todayMatch.game_time.split(":")[1]}`;
              try {
                singleDateMatchesView =
                  singleDateMatchesView +
                  `
                  <div class="featuredPrematchItem">
                    <div class="helperLeftContentMatch">
                      <a href="#/Match/${todayMatch.id}?today=1" class="featuredMatchName">
                        <span>${todayMatch.home_team}</span>
                        <span>${todayMatch.away_team}</span>
                      </a>
                      <span class="featurePreMatchDate">${time}</span>
                      <span class="numberofmarkets">${todayMatch.count_options} ></span>
                    </div>
                    <div class="featuredMatchBtn">
                      <div class="singleHomeOdd bettingBtn ${Math.floor((parseFloat(todayMatch.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100) / 100 == 1 ? "disabledBtn" : ""} ${todayMatch.odd.split(",")[0].split("|")[0]}" match-odd="${(Math.floor((parseFloat(todayMatch.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${todayMatch.home_team}" match-away-name="${todayMatch.away_team}" match-market="${["1", "X", "2"].includes(todayMatch.odd.split(",")[0].split("|")[2]) ? "Rezultat final" : todayMatch.odd.split(",")[0].split("|")[2]}"  match-market-option="1 " coef-id="${todayMatch.odd.split(",")[0].split("|")[0]}" bet-id="${todayMatch.odd.split(",")[0].split("|")[0]}" game-id="${todayMatch.id}"><i>1</i><i>${(Math.floor((parseFloat(todayMatch.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                      <div class="singleDrawOdd bettingBtn ${Math.floor((parseFloat(todayMatch.odd.split(",")[1].split("|")[1]) + Number.EPSILON) * 100) / 100 == 1 ? "disabledBtn" : ""} ${todayMatch.odd.split(",")[1].split("|")[0]}" match-odd="${(Math.floor((parseFloat(todayMatch.odd.split(",")[1].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${todayMatch.home_team}" match-away-name="${todayMatch.away_team}" match-market="${["1", "X", "2"].includes(todayMatch.odd.split(",")[1].split("|")[2]) ? "Rezultat final" : todayMatch.odd.split(",")[1].split("|")[2]}"  match-market-option="X " coef-id="${todayMatch.odd.split(",")[1].split("|")[0]}" bet-id="${todayMatch.odd.split(",")[1].split("|")[0]}" game-id="${todayMatch.id}"><i>X</i><i>${(Math.floor((parseFloat(todayMatch.odd.split(",")[1].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                      <div class="singleAwayOdd bettingBtn ${Math.floor((parseFloat(todayMatch.odd.split(",")[2].split("|")[1]) + Number.EPSILON) * 100) / 100 == 1 ? "disabledBtn" : ""} ${todayMatch.odd.split(",")[2].split("|")[0]}" match-odd="${(Math.floor((parseFloat(todayMatch.odd.split(",")[2].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${todayMatch.home_team}" match-away-name="${todayMatch.away_team}" match-market="${["1", "X", "2"].includes(todayMatch.odd.split(",")[2].split("|")[2]) ? "Rezultat final" : todayMatch.odd.split(",")[2].split("|")[2]}"  match-market-option="2 " coef-id="${todayMatch.odd.split(",")[2].split("|")[0]}" bet-id="${todayMatch.odd.split(",")[2].split("|")[0]}" game-id="${todayMatch.id}"><i>2</i><i>${(Math.floor((parseFloat(todayMatch.odd.split(",")[2].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                    </div>
                  </div>`;
              } catch {}
            }
          });

          leagueView += `
            <div class="singleHeaderHolderLabel fourColumn">
              <div class="singleHeaderLabel">${dayName} ${dd} ${monthName}</div>
              <div class="singleHeaderLabel">1</div>
              <div class="singleHeaderLabel">x</div>
              <div class="singleHeaderLabel">2</div>
            </div>
            ${singleDateMatchesView}
          `;
        });

        matchesView += `
          <div class="singleHeaderHolderLabel newLeagueName" style="display:flex; width:100%;">
            <div class="singleHeaderLabel leagueName" style="width:100%;">${leagueName}</div>
          </div>
          ${leagueView}
        `;
      });

      return matchesView;
    };

    let todayMatchesView = "";
    todayMatchesView = generateMatchesView(todayMatches);

    let view = /*html*/ `
        <div class="pageSection">
            <div class="pageHeaderTitle leaguePageHeader">
                <a class="backBtn" href="#/">
                    <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#939393" d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
                </a>
                <span>
                    ${_t("Futboll")} / 
                </span>
                <div class="dropdownWrapper expand">
                    <div class="dropdownSelectedLabel">${_t(selectedLabelKey)}</div>
                    <div class="dropdownContentItem" style="height: 0; overflow: hidden;">
                        <a href="#/landing/1" class="dropdownItemLinks ${mode === "1" ? "active" : ""}" data-id="1">
                            ${_t("Ndeshjet Sot")}
                        </a>
                        <a  href="#/landing/2"  class="dropdownItemLinks ${mode === "2" ? "active" : ""}" data-id="2">
                            ${_t("Ndeshjet 2 orët e ardhshme")}
                        </a>
                        <a   href="#/landing/3"   class="dropdownItemLinks ${mode === "3" ? "active" : ""}" data-id="3">
                            ${_t("Ndeshjet 4 orët e ardhshme")}
                        </a>
                    </div>
                </div>
            </div>
            <div class="featuredPrematchWrappers" style="height: auto;" id="todayAccordionContent">
                <div class="featuredPrematchSlider" style="position: relative">
                    ${todayMatchesView}
                </div>
            </div>
        </div>
       `;

    return view;
  },
  after_render: async (socket) => {
    // if (LOGIN_PROTECTED === true && !localStorage.getItem("access_token")) {
    //   return;
    // }

    // DROPDOWN TOGGLE
    $(".dropdownSelectedLabel").on("click", function (e) {
      e.stopPropagation();

      const $wrapper = $(this).closest(".dropdownWrapper");
      const $content = $wrapper.find(".dropdownContentItem");

      if ($wrapper.hasClass("open")) {
        // close
        $wrapper.removeClass("open");
        $content.stop().animate({ height: 0 }, 150);
      } else {
        // open
        $(".dropdownWrapper").removeClass("open");
        $(".dropdownContentItem").stop().animate({ height: 0 }, 150);

        $wrapper.addClass("open");

        const itemsCount = $content.find(".dropdownItemLinks").length;
        const itemHeight = 40; // adjust if needed
        const newHeight = itemsCount * itemHeight;

        $content.stop().animate({ height: newHeight }, 150);
      }
    });
  },
  on_unload: async (socket) => {
    socket.emit("leaveRoom", { room: "prematch-games" });
    socket.emit("leaveRoom", { room: "inplay" });
    timers.forEach((timer) => clearInterval(timer.timerId));
  },
};

export default Landing;
